const messages = {
  'aboutUs.groupImgAltText': 'grupo de Mãos Sem Fronteiras',
  'aboutUs.text': 'Este blog é uma iniciativa de ',
  'aboutUs.textSecond': ', que tem como objetivo compartilhar conhecimentos únicos e experiências inspiradoras de todas as partes do mundo.',
  'aboutUs.textThird': 'Convidamos você a conhecer diferentes perspectivas sobre temas como bem-estar, emoções, saúde mental e qualquer outro tema de seu interesse.',
  'aboutUs.textFourth': 'Além disso, compartilhamos testemunhos que revelam os benefícios da Estimulação Neural e meditação, seja no trabalho, estudos, família ou vida pessoal.',
  'aboutUs.textFifth': 'Então relaxe e aproveite cada um dos nossos artigos.',
  'aboutUs.copyright': 'Os artigos neste blog são propriedade de Mãos Sem Fronteiras, salvo indicação em contrário. ',
  'aboutUs.LJQuote': '"O que não se compartilha se perde" – LJ',
  'aboutUs.manos': 'Mãos Sem Fronteiras',

  'article.author': 'Escrito por: ',
  'article.contribute': 'Junte-se à nossa rede de escritores e comparta seu conhecimento em nossa plataforma',

  'category.emptyQuery': 'Não encontramos nenhum artigo',
  'category.mentalHealth': 'Saúde Mental',
  'category.others': 'Outros',
  'category.physicalWellbeing': 'Bem-estar Físico',
  'category.selfawareness': 'Autoconhecimento',
  'category.noMoreViolence': '#porNossaVoz',
  'category.reflections': 'Reflexões',

  'categories.title': 'Categorias',

  'contact.name': 'Nome',
  'contact.email': 'Mail',
  'contact.message': 'Mensagem',
  'contact.submit': 'Enviar',
  'contact.worldMap': 'MSF no Mundo',

  'contribute.text': 'Você quer fazer parte da nossa equipe de colaboradores e colaboradoras do blog? Perfeito, envie-nos um artigo ou testemunho de um tema pelo qual você é apaixonado. ',
  'contribute.secondText': 'Seu conhecimento e suas experiências são a vida deste blog.',
  'contribute.thirdText': 'Não se preocupe se a escrita não é o seu forte, estamos preparados para guiá-lo no processo.',
  'contribute.join': 'Junte-se à nossa rede de escritores e surpreenda-nos com a sua mensagem na nossa próxima "newsletter"! ',
  'contribute.translation': 'Nossa equipe se encargará das traduções',

  'footer.manos.label': 'MSF_int',
  'footer.manos.altText': 'Mundo monocromático',
  'footer.yoMedito.label': 'Eu Medito',
  'footer.yoMedito.altText': 'Balão monocromático',
  'footer.laJardinera.label': 'La Jardinera',
  'footer.laJardinera.altText': 'Flor monocromático',
  'footer.copyright': '© 2018 Mãos Sem Fronteiras',

  'legal.address.label': 'Endereço Registrado',
  'legal.address.line1': 'Manos Sin Fronteras Internacionales',
  'legal.address.line2': 'C/ Ribargorza no. 18',
  'legal.address.line3': 'Entresuelo B de Zaragoza',
  'legal.address.line4': '50003 (Zaragoza)',
  'legal.contact.email': 'Email: ',
  'legal.contact.phone': 'Telefone: +34 658 77 46 78',
  'legal.contact.website': 'Site: ',
  'legal.representative.label': 'Representante Legal',
  'legal.representative.name': 'Lucía Peña',
  'legal.representative.with': 'Registro: Diputación General de Aragón',
  'legal.representative.number': 'Numero de Registro: 01-Z-2070-2007',
  'legal.representative.code': 'Código de Identificação Definitivo: G99197394',
  'legal.disclaimer.label': 'Declaração Legal',
  'legal.disclaimer.text': 'O conteúdo deste web site está baseado em normas da Espanha, salvo indicação expressa em contrário. As opiniões e critérios publicados nos artigos representam os autores e não o Blog de Mãos Sem Fronteiras Internacional e seus criadores. Se existir alguma sugestão ou reclamação a respeito do que foi publicado aqui, agradecemos que se dirija à área "Entre em contato conosco"  para atender seu comunicado. Todos os artigos publicados aqui tem o consentimento expresso de seu autor.',

  'locale.en': 'English',
  'locale.es': 'Español',
  'locale.it': 'Italiano',
  'locale.pt': 'Português',

  'meta.description.aboutUs': 'Somos Mãos Sem Fronteiras e criamos este blog para compartilhar experiências inspiradoras e conhecimentos únicos. Além disso, compartilhamos testemunhos que revelam os benefícios da Estimulação Neural.',
  'meta.description.contactUs': 'Quer compartilhar suas experiências e conhecimentos? Tem comentários ou perguntas sobre o site ou os artigos que publicamos? Escreva-nos uma mensagem e responderemos em seguida.',
  'meta.description.contribute': 'Convidamos você a compartilhar com nossos leitores o tópico pelo qual você é apaixonado ou aquelas experiências que foram fundamentais em seu crescimento pessoal. Seu conhecimento e suas experiências são a vida deste blog!',
  'meta.description.home': 'Bem-vindo ao Blog de Mãos Sem Fronteiras! Convidamos você a desfrutar dos nossos',
  'meta.description.mentalHealth': 'Encontre artigos sobre como lidar com situações e tensões da vida de uma maneira saudável. Leia sobre as situações difíceis com que se encontraram nossos escritores e descubra como eles conseguiram recuperar o bem-estar mental e emocional.',
  'meta.description.others': 'Nesta página você encontrará artigos interessantes de tópicos variados que a equipe que gerencia o blog MSF considera que são importantes para compartilhar, mas eles não são sobre a saúde mental, física ou um testemunho relacionado ao Ensinamento.',
  'meta.description.physicalWellbeing': 'Aqui você encontrará artigos sobre como criar hábitos para melhorar seu  bem-estar físico e a ligação entre as emoções, a saúde mental e a saúde do seu corpo.',
  'meta.description.selfawareness': 'Aprenda como a meditação, a estimulação neural ou viagens especiais aceleraram a autoconsciência de pessoas diferentes e suas experiências nessa jornada para se conhecerem melhor.',
  'meta.description.noMoreViolence': 'Inalo, exalo e eu tomo posse da minha vida, 5 minutos pela minha voz',

  'menu.aboutUs': 'Sobre Nós',
  'menu.contactUs': 'Contate-nos',
  'menu.contribute': 'Contribuir',
  'menu.home': 'Home',
  'menu.legal': 'Representante Legal',

  'sidePanel.estimulacionNeural.altText': 'Estimulação Neural',
  'sidePanel.estimulacionNeural.text': 'Uma técnica para o seu bem-estar físico, mental e emocional.',
  'sidePanel.estimulacionNeural.title': 'Estimulação Neural',
  'sidePanel.laJardinera.altText': 'Flor rosa',
  'sidePanel.laJardinera.text': 'Precurssora da Estimulação Neural dedicou sua vida para ajudar o planeta.',
  'sidePanel.laJardinera.title': 'La Jardinera',
  'sidePanel.yoMedito.altText': 'Balão - Eu Medito',
  'sidePanel.yoMedito.text': 'Quando você tem paz, o mundo tem paz.',
  'sidePanel.yoMedito.title': 'Eu Medito',

  'template.comments': 'Escreva seus comentários',
};

export default messages;
